import { RegistrationCrud } from '@diamond/shared/schema/registration';

export type RegistrationProgressResponse =
  RegistrationCrud['getProgress']['response'];

export interface RegistrationDisplayInfo {
  companyOrOwnerName: string | null;
  picName: string | null;
}

function readStringField(
  record: Record<string, unknown> | null,
  key: string
): string | null {
  if (!record) {
    return null;
  }

  const value = record[key];
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

export function extractRegistrationDisplayInfo(
  progress: RegistrationProgressResponse
): RegistrationDisplayInfo {
  const business = progress.business as Record<string, unknown> | null;

  if (progress.sections.business.ownership_type === 'company') {
    const companyName = readStringField(business, 'company_name');
    const picFirstName = readStringField(business, 'pic_first_name');
    const picLastName = readStringField(business, 'pic_last_name');
    const picName = [picFirstName, picLastName].filter(Boolean).join(' ') || null;

    return {
      companyOrOwnerName: companyName,
      picName,
    };
  }

  const ownerFirstName = readStringField(business, 'owner_first_name');
  const ownerLastName = readStringField(business, 'owner_last_name');
  const ownerName =
    [ownerFirstName, ownerLastName].filter(Boolean).join(' ') || null;

  return {
    companyOrOwnerName: ownerName,
    picName: ownerName,
  };
}
